// import { GlobalState } from '@leverege/ui-redux'

export default { 
  name : 'Subscription Status',
  objectType : 'boat',
  valueType : 'string',
  displayName : 'Subscription Status',
  get : () => null
  // this mostly works but can break due to execution order, so keeping the renderer is more appropriate
  // get : () => GlobalState.get()?.ui?.subscriptionInfo?.valid ? 'Valid' : null
}
